export const GET_MEMBERSHIPPACKAGES_INFO_LOADING = 'REDUX_SAGA_GET_MEMBERSHIPPACKAGES_INFO_LOADING';
export const MEMBERSHIPPACKAGES_DATA_SUCCESS = 'REDUX_SAGA_MEMBERSHIPPACKAGES_DATA_SUCCESS';
export const MEMBERSHIPPACKAGES_DATA_ERROR = 'REDUX_SAGA_MEMBERSHIPPACKAGES_DATA_ERROR';
export const MEMBERSHIPPACKAGES_DATA_RESET = 'REDUX_SAGA_MEMBERSHIPPACKAGES_DATA_RESET';
export const GET_MEMBERSHIPPACKAGE_OBJECT = 'REDUX_SAGA_GET_MEMBERSHIPPACKAGE_OBJECT';
export const UPDATE_MEMBERSHIPPACKAGE = 'REDUX_SAGA_UPDATE_MEMBERSHIPPACKAGE';
export const DELETE_MEMBERSHIPTYPEPERSON = 'REDUX_SAGA_DELETE_MEMBERSHIPTYPEPERSON';
export const UPDATE_MEMBERSHIPADDONS_QUANTITY = 'REDUX_SAGA_UPDATE_MEMBERSHIPADDONS_QUANTITY';
export const UPDATE_PACKAGE_FOR_RENEW = 'REDUX_SAGA_UPDATE_PACKAGE_FOR_RENEW';
export const UPDATE_FAMILYMEMBERS_NOT_PART_OF_PACKAGE = 'REDUX_SAGA_UPDATE_FAMILYMEMBERS_NOT_PART_OF_PACKAGE';
export const MEMBERSHIPPACKAGE_DATA_RESET = 'REDUX_SAGA_MEMBERSHIPPACKAGE_DATA_RESET';

export const actionGetMembershipPackages = (dispatch, DisplayAreaNo) => {
    dispatch({
        type: GET_MEMBERSHIPPACKAGES_INFO_LOADING,
        payload: { DisplayAreaNo: DisplayAreaNo }
    })
};

export const actionGetMembershipPackage = (dispatch, memberpackID) => {
    dispatch({
        type: GET_MEMBERSHIPPACKAGE_OBJECT,
        payload: { memberpackID: memberpackID }
    })
}

export const actionUpdateMembershipPackage = (dispatch, membershipPackageDetails, isEdit) => {
    dispatch({ type: UPDATE_MEMBERSHIPPACKAGE, payload: { membershipPackageDetails: membershipPackageDetails, isEdit: isEdit } })
};

export const actionDeleteMembershipTypePerson = (dispatch, MembershipPackageID, membershipTypeID, userNo) => {
    dispatch({ type: DELETE_MEMBERSHIPTYPEPERSON, payload: { MembershipPackageID: MembershipPackageID, membershipTypeID: membershipTypeID, userNo: userNo } })
};

export const actionUpdateMembershipAddonsQuantity = (dispatch, membershipType) => {
    dispatch({ type: UPDATE_MEMBERSHIPADDONS_QUANTITY, payload: membershipType })
};

export const actionResetMembershipPackages = (dispatch) => {
    dispatch({ type: MEMBERSHIPPACKAGES_DATA_RESET })
};

export const actionResetMembershipPackage = (dispatch) => {
    dispatch({ type: MEMBERSHIPPACKAGE_DATA_RESET })
};

export const actionUpdatePackageForRenew = (dispatch, packageID, memberMemberships, customer) => {
    dispatch({ type: UPDATE_PACKAGE_FOR_RENEW, payload: { packageID: packageID, memberMemberships: memberMemberships, customer: customer } })
};


export const actionUpdateFamilyMemberNotPartOfPackage = (dispatch, userNo, isAdded) => {
    dispatch({ type: UPDATE_FAMILYMEMBERS_NOT_PART_OF_PACKAGE, payload: { userNo: userNo, isAdded: isAdded } })
};
